import { EInfrastructureActionType, ISetFeaturesCountPayload } from './types';
import { actionGenerator } from '../../../common/utils/redux/actionGenerator';

export const setVisibleFeaturesCount = actionGenerator<
  EInfrastructureActionType.SetVisibleFeaturesCount,
  ISetFeaturesCountPayload
>(EInfrastructureActionType.SetVisibleFeaturesCount);
